// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bzz7X","colBig":"styles_colBig__3DyQ1","colSmall":"styles_colSmall__2go1E"};